import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SignOut, User, ShieldCheck } from '@phosphor-icons/react';
import { toast } from 'sonner';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/');
  };

  return (
    <nav className="bg-primary text-text_light p-6 border-b border-borders">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="text-2xl font-semibold hover:text-accent transition-colors" data-testid="nav-logo">
          PestPro Hub
        </Link>
        
        <div className="flex items-center gap-6">
          <Link to="/companies" className="hover:text-accent transition-colors" data-testid="nav-companies">
            Companies
          </Link>
          <Link to="/jobs" className="hover:text-accent transition-colors" data-testid="nav-jobs">
            Jobs
          </Link>
          <Link to="/product-reviews" className="hover:text-accent transition-colors" data-testid="nav-products">
            Products
          </Link>
          <Link to="/pest-id" className="hover:text-accent transition-colors" data-testid="nav-pest-id">
            Pest ID
          </Link>
          <Link to="/blogs" className="hover:text-accent transition-colors" data-testid="nav-blogs">
            Blog
          </Link>
          <Link to="/certifications" className="hover:text-accent transition-colors" data-testid="nav-certifications">
            Certifications
          </Link>
          <Link to="/license-renewal" className="hover:text-accent transition-colors bg-accent/10 px-3 py-1 rounded-sm" data-testid="nav-license">
            License Renewal
          </Link>
          <Link to="/courses" className="hover:text-accent transition-colors" data-testid="nav-courses">
            Courses
          </Link>
          <Link to="/pricing" className="hover:text-accent transition-colors" data-testid="nav-pricing">
            Pricing
          </Link>
          <Link to="/hypersensitivity" className="hover:text-accent transition-colors" data-testid="nav-hypersensitivity">
            Safety
          </Link>
          <Link to="/safety-training" className="hover:text-accent transition-colors" data-testid="nav-safety-training">
            Training
          </Link>
          
          {user ? (
            <div className="flex items-center gap-4 ml-4 pl-4 border-l border-secondary">
              {user.role === 'admin' && (
                <Link
                  to="/admin"
                  className="flex items-center gap-2 hover:text-accent transition-colors"
                  data-testid="nav-admin"
                >
                  <ShieldCheck size={20} />
                  Admin
                </Link>
              )}
              {(user.role === 'employer' || user.role === 'company') && (
                <Link
                  to="/dashboard"
                  className="flex items-center gap-2 hover:text-accent transition-colors"
                  data-testid="nav-dashboard"
                >
                  <User size={20} />
                  Dashboard
                </Link>
              )}
              <span className="text-sm">{user.name}</span>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 hover:text-accent transition-colors"
                data-testid="nav-logout"
              >
                <SignOut size={20} />
                Logout
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-4 ml-4 pl-4 border-l border-secondary">
              <Link
                to="/login"
                className="hover:text-accent transition-colors"
                data-testid="nav-login"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="bg-accent text-white px-4 py-2 rounded-sm hover:bg-accent/90 transition-colors"
                data-testid="nav-register"
              >
                Register
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
